import { combineReducers } from "redux";
import user from "./reducers/dashboard/user";
import company from "./reducers/dashboard/company";
import offers from "./reducers/dashboard/offers";
import quotations from "./reducers/dashboard/quotations";
import roundtrip from "./reducers/app/roundtrips";
import message from "./reducers/dashboard/messages";
import misc from "./reducers/app/misc";
import verification from "./reducers/dashboard/verification";

const rootReducer = combineReducers({
  dashboard: combineReducers({
    company,
    user,
    message,
    offers,
    quotations,
    verification,
  }),
  app: combineReducers({
    roundtrip,
    misc,
  }),
});

export default rootReducer;
